import { Tooltip } from '@material-ui/core';

import { formatPrice } from 'src/services/utils/index';

const priceTableName = (
  <Tooltip title="Valor do produto">
    <td className="text-center">Valor</td>
  </Tooltip>
);

const renderProducPrice = ({ row, fullPrice }) => (
  <span>{row?.price && fullPrice ? formatPrice(fullPrice) : ''}</span>
);

const getPriceColumn = fullPrice => ({
  name: priceTableName,
  cell: row => renderProducPrice({ row, fullPrice }),
  sortable: true,
  grow: 2,
  fontWeight: 'bold',
  center: true,
});

export default getPriceColumn;
